// eslint-disable-next-line eslint-comments/disable-enable-pair -- mocked class
/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars, class-methods-use-this -- mocked class */
import { Time } from 'common/Constants';
import { ISession, ISessionManager, SessionHandler } from 'common/sessions';

export class MockSessionManager implements ISessionManager {
  public readonly sessionTimeoutMs: number;

  private session: ISession | null = {
    id: 'mock-session',
    startedAt: Date.now(),
    updatedAt: Date.now(),
  };

  constructor({
    sessionTimeoutMs = Time.ONE_MINUTE_IN_MS * 360,
  }: {
    readonly sessionTimeoutMs?: number;
  } = {}) {
    this.sessionTimeoutMs = sessionTimeoutMs;
  }

  public getOrCreateSession(): Readonly<ISession> {
    const session = this.session ?? {
      id: 'mock-session',
      startedAt: Date.now(),
      updatedAt: Date.now(),
    };

    this.session = session;
    return session;
  }

  public addNewSessionListener(handler: SessionHandler) {}

  public removeNewSessionListener(handler: SessionHandler) {}

  public touch(): void {}

  public clear(): void {
    this.session = null;
  }
}
